var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Prop } from 'vue-property-decorator';
import StatusCard from '@/components/status-card/StatusCard';
let MoveScoolSnackbar = class MoveScoolSnackbar extends Vue {
    constructor() {
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.isVisible = true;
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    mounted() {
        this.initialize();
    }
    async initialize() {
        //
    }
    // #endregion
    // #region Class methods
    close() {
        this.$emit('close');
        this.$emit('input', false);
    }
    onClick(action) {
        if (!action.click) {
            throw new Error('You have not added a click to this ASnackBar action. Please add either a \'click\' or a \'to\' property to this action');
        }
        else {
            action.click();
        }
    }
    async onStatusChanged(status, isDefault) {
        this.$emit('statusChanged', status, isDefault);
    }
    // #endregion
    // #region Async methods
    // #endregion
    // #region Getters & Setters
    get internalTimeout() {
        return this.permanent ? 0 : this.timeout;
    }
    get count() {
        return (this.subjects && this.subjects.length) || 0
            + (this.topics && this.topics.length) || 0;
    }
};
__decorate([
    Prop({ default: 'bottom' }),
    __metadata("design:type", String)
], MoveScoolSnackbar.prototype, "position", void 0);
__decorate([
    Prop({ default: 0 }),
    __metadata("design:type", Number)
], MoveScoolSnackbar.prototype, "timeout", void 0);
__decorate([
    Prop({ default: () => [] }),
    __metadata("design:type", Array)
], MoveScoolSnackbar.prototype, "actions", void 0);
__decorate([
    Prop({ default: () => ([]) }),
    __metadata("design:type", Array)
], MoveScoolSnackbar.prototype, "topics", void 0);
__decorate([
    Prop({ default: () => ([]) }),
    __metadata("design:type", Array)
], MoveScoolSnackbar.prototype, "subjects", void 0);
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], MoveScoolSnackbar.prototype, "visible", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], MoveScoolSnackbar.prototype, "permanent", void 0);
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], MoveScoolSnackbar.prototype, "collapsable", void 0);
MoveScoolSnackbar = __decorate([
    Component({
        components: {
            StatusCard,
        },
    })
], MoveScoolSnackbar);
export default MoveScoolSnackbar;
